module.exports = __webpack_public_path__ + "img/frame (176).192290ba.jpg";